import { render, staticRenderFns } from "./item-image.vue?vue&type=template&id=31eefefd&scoped=true"
import script from "./item-image.vue?vue&type=script&setup=true&lang=js"
export * from "./item-image.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-image.vue?vue&type=style&index=0&id=31eefefd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eefefd",
  null
  
)

export default component.exports